import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import UserflowTheme from '@lt/components/themes/userflow';
import { TestimonialsFormApp } from 'src/routes/TestimonialsForm/TestimonialsFormApp';
import HeaderApp from 'src/routes/HeaderApp';
import { getStore } from 'src/routes/HeaderApp/store';
import ErrorBoundary from 'src/error/components/ErrorBoundary';
import { LocalizationProvider } from '@lt/localization';

export default () => {
  const {
    isWidgetShown,
    isFontsBlack,
    isTransparentHeader,
    availableSearchTypes,
  } = window;

  const headerNode = document.querySelector('#lt-header-app');
  const node = document.getElementById('testimonials-form-app');
  const store = getStore({
    isWidgetShown,
    isFontsBlack,
    isTransparentHeader,
    availableSearchTypes,
  });

  if (headerNode) {
    render(<HeaderApp store={store} />, headerNode);
  }
  if (node) {
    render(
      <ErrorBoundary>
        <LocalizationProvider>
          <Provider store={store}>
            <UserflowTheme>
              <TestimonialsFormApp />
            </UserflowTheme>
          </Provider>
        </LocalizationProvider>
      </ErrorBoundary>,
      node,
    );
  }
};
